import React from 'react'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
const projects = [

    {
        id: 1,
        title: "Automating Success with Testing for Great Dwellings",
        category: "Web",
    imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d1e57d45178d9ce5006d6_GreatDwellings2B_1260.jpg",
        content: "This project involved developing and automating a comprehensive testing suite for a real estate platform, ensuring seamless user experiences and robust functionality across all devices.",

    },
    {
        id: 2,
        title: "UI Design and Branding for Children’s Book Series",
        category: "Branding",
        imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/62321cbe7fd75424e426e23d_NetAesthetics_Portfolio_Noah-and-Blue-Banner.jpg",
        content: "Created a vibrant and engaging UI design and branding strategy for a popular children's book series, focusing on playful aesthetics and an intuitive user interface to captivate young readers."
    },
    {
        id: 3,
        title: "ERC's Fair Housing Checklist Mobile App",
        category: "Mobile",
        imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/6273985f162e55b6627b2d95_NetAesthetics_Portfolio_Fair-Housing-Thumbnail.jpg",
        content: "Developed a mobile application for the Equal Rights Center to assist users in adhering to fair housing practices, complete with a customizable checklist and real-time reporting features."
    },
    {
        id: 4,
        title: "Cloud-based Mobile App for Smarter Voting",
        content: "Designed and developed a secure cloud-based mobile application to streamline the voting process, making it easier and more accessible for users to participate in elections with enhanced security features."
    },
    {
        id: 5,
        title: "Blackbox Testing the Yelp for those with Disabilities",
        content: "Conducted extensive blackbox testing on a Yelp-like platform tailored for users with disabilities, ensuring that all accessibility features were thoroughly tested and optimized for user inclusivity."
    },
    {
        id: 6,
        title: "Revolutionizing Student Mental Health Support",
        content: "Led the development of a cutting-edge platform aimed at providing mental health support to students, integrating AI-driven assessments and real-time counseling options to enhance the well-being of students."
    },
    {
        id: 7,
        title: "Microsite for Millennial-Centric Real Estate Property",
        content: "Developed a sleek and modern microsite targeted at millennial homebuyers, focusing on clean design, user-friendly navigation, and interactive features to highlight properties and their unique selling points."
    },
    {
        id: 8,
        title: "Shopify: Spreading Love & Freshwater",
        content: "Collaborated on a Shopify e-commerce platform dedicated to selling products that support global clean water initiatives, with a focus on creating a compelling brand story and seamless shopping experience."
    },
    {
        id: 9,
        title: "COVID Fundraiser UI/UX Design Services",
        content: "Designed a user-friendly UI/UX for a COVID-19 fundraiser platform, aimed at maximizing donations through intuitive navigation, engaging visuals, and a streamlined donation process."
    },
    {
        id: 10,
        title: "Interactive Guidebooks for Airbnbs",
        content: "Created interactive digital guidebooks for Airbnb hosts, offering customizable templates that enhance the guest experience by providing personalized recommendations and essential local information."
    },
    {
        id: 11,
        title: "AI-Powered Healthcare Dashboard",
        content: "Developed an AI-powered dashboard for healthcare professionals, providing real-time analytics, patient tracking, and predictive insights to improve patient outcomes and streamline healthcare management."
    },
    {
        id: 12,
        title: "Virtual Event Platform for Conferences",
        content: "Designed and launched a virtual event platform tailored for large-scale conferences, featuring live streaming, networking opportunities, and interactive sessions to replicate the in-person conference experience."
    }
];



function PortfolioCardArticleDetail() {
    const { id } = useParams();
    const project = projects.find(project => project.id.toString() === id);

    if (!project) {
        return <h2>Article not found</h2>;
    }

    return (
        <>
            <div className='portfolio_card_author_detail_page'>
                <div className='category_portfolio_container'>
                    <div>
                        <div className='category_tag_portfolio'>
                            <div className='multitextblurgradiantportfolio'></div>
                            <div>
                                <div className='multitextportfolio'>
                                    Web Application
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h1 className='portfoliotitle'>{project.title}</h1>
                <p className='portfolioparagraph'>{project.content}</p>
                <div className='portfolio_author_container'>
                    <div className='portfolio_image_container'>
                        <img className='portfolioclientimage' src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/62166f42de6d5a2af5ad52de_NetAesthetics_Client-Logo_ERC.jpg" alt="" />
                    </div>
                    <div>
                        <div className='portfolio_author_name'>Equal Rights Center

                        </div>


                        <div>Client</div>
                    </div>

                </div>
                <div class="contact_social_media_links sociallink"><a class="social_media_link" target="_blank" href="https://www.facebook.com/NetAesthetics/"><img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11507f77e9ffbee3b49d3_NetAetshetics%20Social%20Icon%20-%20Facebook.svg" alt="" /></a><a class="social_media_link" target="_blank" href="https://www.instagram.com/netaesthetics/"><img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d1150862b7fa02c26b07b0_NetAetshetics%20Social%20Icon%20-%20Instagram.svg" alt="" /></a><a class="social_media_link" target="_blank" href="https://www.linkedin.com/company/netaesthetics/"><img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d115079c5e182becc9024a_NetAetshetics%20Social%20Icon%20-%20LinkedIn.svg" alt="" /></a><a class="social_media_link" target="_blank" href="https://www.upwork.com/ag/netaesthetics/"><img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11508550a566ce87de603_NetAetshetics%20Social%20Icon%20-%20UpWork.svg" alt="" /></a><a class="social_media_link" target="_blank" href="https://www.crunchbase.com/organization/netaesthetics"><img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11507b378db2d3e116613_NetAetshetics%20Social%20Icon%20-%20Crunchbase.svg" alt="" /></a></div>
            </div>
            <div class="portfolio_detail_page_image" ><img style={{ borderRadius: '30px' }} class="mainimage" src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d1e57d45178d9ce5006d6_GreatDwellings2B_1260.jpg" alt="" /></div>


            <div class="section-portfolio" >
                <div class="container-portfolio">
                    <div data-w-id="235059ed-62d8-6cf4-b66d-b1bc47bc606d" style={{ transform: "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg)", transformStyle: "preserve-3d", opacity: 1 }} class="portfolio-wrapper">
                        <div class="portfolio-column-left">
                          
                            <div class="rich-text w-richtext">
                                <p>This short-term real estate property management company needed a web presence that would attract both clients for whom they could manage their properties and to attract guests who would stay in those homes. Delivering that was only the start. Once the search engine optimized site was built, they quickly rose to
                                    <strong className='googlefont'>Google’s front page</strong>
                                    , which led to large numbers of incoming leads. We then fully integrated HubSpot (a best of breed marketing, sales, customer service, and CRM software) throughout the site. As sales grew,
                                    <strong className='googlefont'>we saved them 40 hours a week</strong>
                                    by automating their invoicing process, including calculating commissions and payouts for over 1000 reservations per month.</p>
                                <h2>What we provided Great Dwellings</h2>
                                <p>We utilized a clean layout for the development of the web app for Great Dwellings. This is to ensure that we do not discourage visitors by lessening the clutter. When creating a website, users do tend to overdo their designs that it becomes counterproductive. Other features that we integrated include the following:</p>
                                <ul role="list">
                                    <li>A calculator that computes potential earnings</li>
                                    <li>Social media links at the upper right corner</li>
                                    <li>Listings of available properties</li></ul>

                                <div class="portfolio_detail_page_image" style={{ marginBottom: '50px', paddingLeft: '0px' }} ><img style={{ borderRadius: '30px' }} class="mainimage" src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d1e57d45178d9ce5006d6_GreatDwellings2B_1260.jpg" alt="" /></div>

                                <div class="portfolio_detail_page_image" style={{ marginBottom: '50px', paddingLeft: '0px' }}> <img style={{ borderRadius: '30px' }} class="mainimage" src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d02a5158cc389c569971d_GreatDwellingsKitchen.jpg" loading="lazy" alt="" /></div>


                                <div class="portfolio_detail_page_image" style={{ marginBottom: '50px', paddingLeft: '0px' }}>
                                    <img style={{ borderRadius: '30px' }} class="mainimage" src="https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d02b2aab4a2ed089fb475_ScreenshotGreatDwellingsV2.jpg" loading="lazy" alt="" />
                                </div>

                                <h2>What does Great Dwellings offer?</h2><p>Great Dwellings is a real-estate property management company that helps get property owners and developers tenants to rent their properties. They particularly specialize in short-term rentals. They could even help you calculate how much you could possibly earn renting your properties. However, this doesn’t mean that they only cater to rentees. In fact, they also offer services to those who are looking to rent out homes. They have a catalog from which you can choose from. If there is anything from their list that you like, you can directly contact them. Although, with their desire to increase their online presence, making inquiries might just become easier than it already is. We also make sure that they are able to accommodate the needs of renters. This is because Great Dwellings is trying to accommodate both sides of the spectrum. By doing so, they cater to everyone who is in need of their services in the industry, thereby increasing the likelihood of an increase in traffic. This eventually happened, even more so when the website was search engine optimized. This gives them a boost in the ranks. In fact, Google’s algorithm rises it enough that it ended up on the first page. As a result, the agency sees a sudden spike in the traffic. This further improves when they fully integrated HubSpot throughout the site. Additionally, with our help, Great Dwellings are saving at least 40 more hours in a week by testing the automation of their invoice process. This already includes calculating commissions and the payouts for the reservations in a month, and this can be at least a thousand. Let’s collaborate</p>
                            </div>
                        </div>
                        <div class="portfolio-column-right">
                            <h2 class="portfolio-heading-2">Technology Stack</h2><div class="project-details-wrapper">
                                <div class="image-wrapper blog-post-author icon-wrapper">
                                    <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/620fa8f065202ef97ff29e40_Platform.svg" loading="lazy" alt="" class="technology-stack-icon" />
                                </div>
                                <div class="project-details">
                                    <h3 class="project-heading">Platform</h3>
                                    <div>Web Application</div>
                                </div>
                            </div>
                            <div class="project-details-wrapper">
                                <div class="image-wrapper blog-post-author icon-wrapper">
                                    <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/620fa8f095ca809e3827fa94_Programming%20Language.svg" loading="lazy" alt="" class="technology-stack-icon" />
                                </div>
                                <div class="project-details">
                                    <h3 class="project-heading">Programming languages</h3>
                                    <div>JavaScript</div>
                                </div>
                            </div>
                            <div class="project-details-wrapper">
                                <div class="image-wrapper blog-post-author icon-wrapper">
                                    <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/620fd9be1fd0bd35821d8a13_Frameworks%20and%20tools.svg" loading="lazy" alt="" class="technology-stack-icon" />
                                </div>
                                <div class="project-details">
                                    <h3 class="project-heading">Frameworks and tools</h3>
                                    <div>JQuery, Google Analytics, and GoHighLevel</div>
                                </div>
                            </div>
                            <div class="project-details-wrapper">
                                <div class="image-wrapper blog-post-author icon-wrapper">
                                    <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/620fa8f05899328539abb355_Database.svg" loading="lazy" alt="" class="technology-stack-icon" />
                                </div>
                                <div class="project-details">
                                    <h3 class="project-heading">Databases</h3>
                                    <div>Amazon Web Services</div>
                                </div>
                            </div>
                            <div class="project-link" >

                              
                                <div class="getstartedbutton"><a href="/contact" class="nav-link text-white ">Contact Us</a></div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div className='blog_container px-4  relatedprojects' style={{display:'flex',justifyContent:'space-between',  }}> <h2 className='services_title wow animate__fadeInUp' data-wow-duration="1s" style={{ marginBottom: '50px', marginTop: '50px', }}>
                    Related Projects
                </h2>
                <div className='seemore_con'>
                    <a  style={{marginBottom:'20px'}} href="/portfolio">
                        Brows All
                    </a>
                </div>
                </div>
            <div className='blog_section wow animate__fadeInUp' data-wow-duration="1s">
          
        {projects.slice(0,3).map(project => (
            <Card className='muicard' key={project.id}>
                <Box
                    sx={{
                        position: 'relative',
                        height: 265,
                        backgroundImage: `url(${project.imageUrl})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <Box className="categorytext" sx={project.customStyle}>
                        {project.category}
                    </Box>
                </Box>
                <CardContent style={{textAlign:'left'}}>
                    <a  href={`/portfolio/${project.id}`} className='typographytext' variant="body2">
                        {project.title}
                    </a>
                </CardContent>
                <CardActions sx={{
                    flexDirection: 'column',
                    textAlign: 'left',
                    alignItems: 'flex-start',
                }}>
                    <a  href={`/portfolio/${project.id}`} className='muireadmore'>Read More <span className="arrow_icon"> ↗</span></a>
                    <div className='underline_animation'></div>
                </CardActions>
            </Card>
        ))}
    </div>
        </>
    )
}

export default PortfolioCardArticleDetail